<div class="customer-info-step">
  <form
    [formGroup]="customerInfoForm"
    class="row g-3"
  >
    <!-- Services to Onboard Section -->
    <div class="col-12">
      <div class="config-section">
        <h5 class="section-title mb-3">
          <kendo-svg-icon
            [icon]="checkIcon"
            class="me-2"
          ></kendo-svg-icon>
          Services to Onboard
        </h5>
        <div class="services-selection">
          <div class="row g-3">
            @for (service of availableServices; track service.value) {
              <div class="col-md-6 col-lg-4 col-xl">
                <div
                  class="service-option-card"
                  [class.selected]="isServiceSelected(service.value)"
                  (click)="toggleService(service.value)"
                  role="button"
                  tabindex="0"
                  (keydown.enter)="toggleService(service.value)"
                  (keydown.space)="toggleService(service.value)"
                >
                  <div class="service-option-header">
                    <div
                      class="service-icon"
                      [style.background-color]="service.iconBackground"
                    >
                      <kendo-svg-icon
                        [icon]="service.icon"
                        size="large"
                      ></kendo-svg-icon>
                    </div>
                  </div>
                  <div class="service-name">{{ service.label }}</div>
                  <div class="service-description">{{ service.description }}</div>
                  <div class="selection-indicator">
                    @if (isServiceSelected(service.value)) {
                      <span class="selected-text">Selected</span>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
          @if (customerInfoForm.get('selectedServices')?.invalid && customerInfoForm.get('selectedServices')?.touched) {
            <div class="text-danger mt-2">
              <small>Please select at least one service</small>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Customer Information Section -->
    <div class="col-6 d-flex">
      <div class="config-section flex-fill">
        <h5 class="section-title mb-3">
          <kendo-svg-icon
            [icon]="userIcon"
            class="me-2"
          ></kendo-svg-icon>
          Customer Details
        </h5>
        <div class="row g-3">
          <div class="col-md-6">
            <kendo-formfield>
              <kendo-label
                [for]="customerName"
                text="Customer Name *"
              ></kendo-label>
              <kendo-textbox
                formControlName="customerName"
                #customerName
                placeholder="Enter customer business name"
                class="w-100"
              ></kendo-textbox>
              @if (customerInfoForm.get('customerName')?.invalid && customerInfoForm.get('customerName')?.touched) {
                <kendo-formerror>Customer name is required</kendo-formerror>
              }
            </kendo-formfield>
          </div>

          <div class="col-md-6">
            <kendo-formfield>
              <kendo-label
                [for]="friendlyName"
                text="Friendly Name *"
              ></kendo-label>
              <kendo-textbox
                formControlName="friendlyName"
                #friendlyName
                placeholder="Name for ticket system parsing"
                class="w-100"
              ></kendo-textbox>
              @if (customerInfoForm.get('friendlyName')?.invalid && customerInfoForm.get('friendlyName')?.touched) {
                <kendo-formerror>Friendly name is required</kendo-formerror>
              }
            </kendo-formfield>
          </div>

          <div class="col-md-6">
            <kendo-formfield>
              <kendo-label
                [for]="preferredGoLiveDate"
                text="Preferred Go Live Date *"
              ></kendo-label>
              <kendo-datepicker
                formControlName="preferredGoLiveDate"
                #preferredGoLiveDate
                placeholder="Select preferred go live date"
                class="w-100"
              ></kendo-datepicker>
              @if (
                customerInfoForm.get('preferredGoLiveDate')?.invalid &&
                customerInfoForm.get('preferredGoLiveDate')?.touched
              ) {
                <kendo-formerror>Preferred go live date is required</kendo-formerror>
              }
            </kendo-formfield>
          </div>

          <div class="col-md-6">
            <kendo-formfield>
              <kendo-label
                [for]="slaLevel"
                text="SLA Subscription Level *"
              ></kendo-label>
              <kendo-dropdownlist
                formControlName="slaLevel"
                #slaLevel
                [data]="slaOptions"
                textField="text"
                valueField="value"
                placeholder="Select SLA level"
                class="w-100"
              ></kendo-dropdownlist>
              <kendo-formhint class="sla-info-hint">
                <div class="sla-hint-content">
                  <div class="info-section">
                    <span>Please reference our SLA program link and select 'SOC Support & SLA' document:</span>
                  </div>
                  <div>
                    <a
                      href="https://cyflare.com/legal"
                      target="_blank"
                    >
                      cyflare.com/legal
                    </a>
                  </div>
                  <div class="warning-section">
                    <kendo-svg-icon
                      [icon]="exclamationTriangleIcon"
                      class="me-2 warning-icon"
                    ></kendo-svg-icon>
                    <span class="warning-text">
                      <strong>NOTE:</strong>
                      Does NOT apply to VSS-Lite Service
                    </span>
                  </div>
                </div>
              </kendo-formhint>
              @if (customerInfoForm.get('slaLevel')?.invalid && customerInfoForm.get('slaLevel')?.touched) {
                <kendo-formerror>SLA selection is required</kendo-formerror>
              }
            </kendo-formfield>
          </div>
        </div>
      </div>
    </div>

    <!-- Shipping Information Section -->
    <div class="col-6 d-flex">
      <div class="config-section flex-fill">
        <h5 class="section-title mb-3">
          <kendo-svg-icon
            [icon]="truckIcon"
            class="me-2"
          ></kendo-svg-icon>
          Shipping Information
        </h5>
        <div class="row g-3">
          <div class="col-md-6">
            <kendo-formfield>
              <kendo-label
                [for]="shippingContactName"
                text="Contact Name"
              ></kendo-label>
              <kendo-textbox
                formControlName="shippingContactName"
                #shippingContactName
                placeholder="Enter contact name"
                class="w-100"
              ></kendo-textbox>
            </kendo-formfield>
          </div>

          <div class="col-md-6">
            <kendo-formfield>
              <kendo-label
                [for]="shippingContactPhone"
                text="Contact Phone #"
              ></kendo-label>
              <kendo-textbox
                formControlName="shippingContactPhone"
                #shippingContactPhone
                placeholder="Enter phone number"
                class="w-100"
              ></kendo-textbox>
            </kendo-formfield>
          </div>

          <div class="col-12">
            <kendo-formfield>
              <kendo-label
                [for]="shippingAddress"
                text="Shipping Address"
              ></kendo-label>
              <kendo-textarea
                formControlName="shippingAddress"
                #shippingAddress
                placeholder="Enter shipping address"
                [rows]="3"
                class="w-100"
              ></kendo-textarea>
            </kendo-formfield>
          </div>

          <div class="col-md-4">
            <kendo-formfield>
              <kendo-label
                [for]="shippingState"
                text="State"
              ></kendo-label>
              <kendo-textbox
                formControlName="shippingState"
                #shippingState
                placeholder="Enter state"
                class="w-100"
              ></kendo-textbox>
            </kendo-formfield>
          </div>

          <div class="col-md-4">
            <kendo-formfield>
              <kendo-label
                [for]="shippingCity"
                text="City"
              ></kendo-label>
              <kendo-textbox
                formControlName="shippingCity"
                #shippingCity
                placeholder="Enter city"
                class="w-100"
              ></kendo-textbox>
            </kendo-formfield>
          </div>

          <div class="col-md-4">
            <kendo-formfield>
              <kendo-label
                [for]="shippingZipCode"
                text="Zip Code"
              ></kendo-label>
              <kendo-textbox
                formControlName="shippingZipCode"
                #shippingZipCode
                placeholder="Enter zip code"
                class="w-100"
              ></kendo-textbox>
            </kendo-formfield>
          </div>
        </div>
      </div>
    </div>

    <!-- Additional Shipping Locations Section -->
    <div class="col-12">
      <div class="config-section">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="section-title mb-0">
            <kendo-svg-icon
              [icon]="geoAltIcon"
              class="me-2"
            ></kendo-svg-icon>
            Additional Shipping Locations
          </h5>
          <button
            type="button"
            kendoButton
            (click)="addAdditionalLocation(); $event.stopPropagation()"
            class="btn-sm"
          >
            <kendo-svg-icon
              [icon]="plusIcon"
              class="me-1"
            ></kendo-svg-icon>
            Add Location
          </button>
        </div>

        <kendo-formhint class="mb-3">
          <kendo-svg-icon
            [icon]="infoCircleIcon"
            class="me-1"
          ></kendo-svg-icon>
          If more than one location - please list shipping addresses below
        </kendo-formhint>

        @for (location of additionalLocationsArray().controls; track $index) {
          <div class="additional-location-card mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Location {{ $index + 1 }}</h6>
              <button
                type="button"
                kendoButton
                (click)="removeAdditionalLocation($index); $event.stopPropagation()"
                class="btn-sm btn-outline-danger"
              >
                <kendo-svg-icon
                  [icon]="minusIcon"
                  class="me-1"
                ></kendo-svg-icon>
                Remove
              </button>
            </div>

            <div
              [formGroup]="getAdditionalLocationFormGroup($index)"
              class="row g-3"
            >
              <div class="col-md-6">
                <kendo-formfield>
                  <kendo-label
                    [for]="'contactName' + $index"
                    text="Contact Name"
                  ></kendo-label>
                  <kendo-textbox
                    formControlName="contactName"
                    [id]="'contactName' + $index"
                    placeholder="Enter contact name"
                    class="w-100"
                  ></kendo-textbox>
                </kendo-formfield>
              </div>

              <div class="col-md-6">
                <kendo-formfield>
                  <kendo-label
                    [for]="'contactPhone' + $index"
                    text="Contact Phone"
                  ></kendo-label>
                  <kendo-textbox
                    formControlName="contactPhone"
                    [id]="'contactPhone' + $index"
                    placeholder="Enter phone number"
                    class="w-100"
                  ></kendo-textbox>
                </kendo-formfield>
              </div>

              <div class="col-12">
                <kendo-formfield>
                  <kendo-label
                    [for]="'address' + $index"
                    text="Address"
                  ></kendo-label>
                  <kendo-textarea
                    formControlName="address"
                    [id]="'address' + $index"
                    placeholder="Enter address"
                    [rows]="2"
                    class="w-100"
                  ></kendo-textarea>
                </kendo-formfield>
              </div>

              <div class="col-md-4">
                <kendo-formfield>
                  <kendo-label
                    [for]="'state' + $index"
                    text="State"
                  ></kendo-label>
                  <kendo-textbox
                    formControlName="state"
                    [id]="'state' + $index"
                    placeholder="Enter state"
                    class="w-100"
                  ></kendo-textbox>
                </kendo-formfield>
              </div>

              <div class="col-md-4">
                <kendo-formfield>
                  <kendo-label
                    [for]="'city' + $index"
                    text="City"
                  ></kendo-label>
                  <kendo-textbox
                    formControlName="city"
                    [id]="'city' + $index"
                    placeholder="Enter city"
                    class="w-100"
                  ></kendo-textbox>
                </kendo-formfield>
              </div>

              <div class="col-md-4">
                <kendo-formfield>
                  <kendo-label
                    [for]="'zipCode' + $index"
                    text="Zip Code"
                  ></kendo-label>
                  <kendo-textbox
                    formControlName="zipCode"
                    [id]="'zipCode' + $index"
                    placeholder="Enter zip code"
                    class="w-100"
                  ></kendo-textbox>
                </kendo-formfield>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </form>
</div>
